export default (url = "") =>
  url.replace(
    /https?:\/\/((admin|cdn)\.)?herb\.co\/wp-content/g,
    `${process.env.GATSBY_LEGACY_CDN}/wp-content`
  );
